import { type FC } from 'react';

import { WithGap } from './WithGap';

interface PageHeadingProps {
  header: string;
  ingress?: React.ReactNode;
}

export const PageHeading: FC<PageHeadingProps> = ({ header, ingress }) => (
  <>
    {!!header && (
      <WithGap>
        <h1>{header}</h1>
        {!!ingress && <div className="font-body-large">{ingress}</div>}
      </WithGap>
    )}
  </>
);
